import {
  TextField,
  FormField,
  formFieldRequiredLabel as requiredLabel,
  PasswordField,
  DropDown,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';
import { DREMIO_HOST_OPTIONS } from './constants';

const DremioFormContent = ({ disabled }: { disabled?: boolean }) => {
  const methods = useFormContext();
  const {
    register,
    formState: { errors, dirtyFields },
    setValue,
    watch,
  } = methods;

  return (
    <>
      <FormField
        title="Host"
        errorMessage={errors.dremioHost?.message as string}
      >
        <DropDown
          {...register('dremioHost', {
            required: requiredLabel,
          })}
          sx={{ height: '53px !important' }}
          options={DREMIO_HOST_OPTIONS}
          value={watch('dremioHost')}
          onChange={(value) => setValue('dremioHost', value)}
          placeholder="e.g. api.dremio.cloud"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Project ID"
        errorMessage={errors.dremioProjectId?.message as string}
      >
        <TextField
          {...register('dremioProjectId', {
            required: requiredLabel,
          })}
          placeholder="The ID of the project"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="User"
        errorMessage={errors.dremioUser?.message as string}
      >
        <TextField
          {...register('dremioUser', {
            required: requiredLabel,
          })}
          placeholder="e.g. elementary_user"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Token"
        errorMessage={errors.dremioToken?.message as string}
      >
        <PasswordField
          {...register('dremioToken', {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields.dremioToken}
          clearFormValue={() => methods.setValue('dremioToken', '')}
          placeholder="Token"
          disabled={disabled}
          size="large"
        />
      </FormField>
    </>
  );
};

export default DremioFormContent;
